import { Filter, ItemFilterBase, TextFilterBase } from './types';
import { itemDefaultModes, textDefaultModes } from './modes';

export const getFilterValidator =
  // eslint-disable-next-line max-statements, complexity
  (filterBases: { [key: string]: TextFilterBase | ItemFilterBase }) => (filter: Filter) => {
    if (!filterBases[filter.name]) {
      throw new Error('Invalid filter name');
    }

    const filterForValidation = filterBases[filter.name];

    if (filter.type !== filterForValidation.type) {
      throw new Error('Invalid filter type');
    }

    if (typeof filter.id !== 'string' || filter.id.length === 0) {
      throw new Error('Invalid filter id');
    }

    let allowedModes = filterForValidation.allowedModes ? Object.keys(filterForValidation.allowedModes) : undefined;

    if (!allowedModes) {
      switch (filterForValidation.type) {
        case 'item':
          allowedModes = itemDefaultModes;
          break;
        case 'text':
          allowedModes = textDefaultModes;
          break;
        default:
          throw new Error('Unsupported filter mode');
      }
    }

    if (!allowedModes.includes(filter.value.mode)) {
      throw new Error('Invalid filter mode');
    }

    if (filterForValidation.type === 'item') {
      if (!Array.isArray(filter.value.value) || filter.value.value.length === 0) {
        throw new Error('Invalid filter value');
      }

      // some item filters only allow a selection against a single item in some modes
      const isSingle = filterForValidation.allowedModes
        ? filterForValidation.allowedModes[filter.value.mode] === 'singleSelect'
        : false;

      if (isSingle && filter.value.value.length > 1) {
        throw new Error('Invalid filter value');
      }

      const valuesAreStrings =
        Array.isArray(filter.value.value) &&
        filter.value.value.every((value) => typeof value === 'string' && value.length > 0);

      if (!valuesAreStrings) {
        throw new Error('Invalid filter value');
      }
    } else if (
      filterForValidation.type === 'text' &&
      (typeof filter.value.value !== 'string' || filter.value.value.length === 0)
    ) {
      throw new Error('Invalid filter value');
    }
  };
